import { useAuth0 } from "@auth0/auth0-react";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import PageLoader from "../components/forms/page-loader";
import { getUserValidated } from "../services/interceptors";
import CommonErrorPage from "../components/Error-Components/common-error-page";
import { useTranslation } from "react-i18next";
import { eventBus } from "../utils/eventBus";
import { EVENTS } from "../utils/eventTypes";
import { useAuthLogout } from "./authLogout";

function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const { t } = useTranslation();
  const [isValid, setIsValid] = useState(getUserValidated()); // ✅ backend validation
  const { appLogout } = useAuthLogout();

  // Listen for validation state changes
  useEffect(() => {
    const handleValidationSuccess = () => {
      setIsValid(true);
    };

    const handleValidationError = (errorCode) => {
      if (errorCode === 20004) {
        setIsValid(false);
      }
    };

    eventBus.on(EVENTS.FETCH_VALIDATE_USER_SUCCESS, handleValidationSuccess);

    eventBus.on(EVENTS.FETCH_VALIDATE_USER_ERROR, handleValidationError);

    return () => {
      eventBus.off(EVENTS.FETCH_VALIDATE_USER_SUCCESS, handleValidationSuccess);

      eventBus.off(EVENTS.FETCH_VALIDATE_USER_ERROR, handleValidationError);
    };
  }, []);

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect({
        appState: {
          returnTo: window.location.pathname,
        },
      });
    }
  }, [isAuthenticated, isLoading, loginWithRedirect]);

  // 🔄 Still loading auth0 OR validation
  if (isLoading || isValid === null) {
    return <PageLoader open={true} />;
  }

  if (!isAuthenticated) {
    return null;
  }

  // ❌ Authenticated but backend validation failed
  if (!isValid) {
    return (
      <CommonErrorPage
        onActionClick={appLogout}
        code="20004"
        title={t("error.20004.title")}
        description={t("error.20004.description")}
        content={t("error.20004.content")}
        content1={t("error.20004.content1")}
        image="/image/no_accounts.svg"
        actionLabel={t("error.20004.actionLabel")}
        phoneNubmer={t("error.20004.actionType.phone.value")}
        mailId={t("error.20004.actionType.mail.value")}
      />
    );
  }

  return children;
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProtectedRoute;
